const ESRI = 'https://server.arcgisonline.com/ArcGIS/rest/services';
const OSM_ATTR = '&copy; OpenStreetMap contributors';

export const BASE_LAYERS = {
  map: {
    label: 'Harita',
    url: `${ESRI}/World_Street_Map/MapServer/tile/{z}/{y}/{x}`,
    attribution: 'Tiles &copy; Esri — HERE, Garmin, &copy; OpenStreetMap contributors',
  },
  satellite: {
    label: 'Uydu',
    url: `${ESRI}/World_Imagery/MapServer/tile/{z}/{y}/{x}`,
    attribution: 'Tiles &copy; Esri — Maxar, Earthstar Geographics',
  },
};
export const LABELS_OVERLAYS = [
  `${ESRI}/Reference/World_Transportation/MapServer/tile/{z}/{y}/{x}`,
  `${ESRI}/Reference/World_Boundaries_and_Places/MapServer/tile/{z}/{y}/{x}`,
];

// Ayarlanabilir sağlayıcı katmanları: "<sağlayıcı>:<stil>"
export const PROVIDER_LAYERS = {
  'esri:map': { provider: 'esri', ...BASE_LAYERS.map, label: 'Esri Sokak' },
  'esri:satellite': { provider: 'esri', ...BASE_LAYERS.satellite, label: 'Esri Uydu', overlays: LABELS_OVERLAYS },
  'esri:light': { provider: 'esri', label: 'Esri Açık Gri', url: `${ESRI}/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}`, attribution: 'Tiles &copy; Esri', overlays: [`${ESRI}/Canvas/World_Light_Gray_Reference/MapServer/tile/{z}/{y}/{x}`] },
  'esri:dark': { provider: 'esri', label: 'Esri Koyu Gri', url: `${ESRI}/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}`, attribution: 'Tiles &copy; Esri', overlays: [`${ESRI}/Canvas/World_Dark_Gray_Reference/MapServer/tile/{z}/{y}/{x}`] },
  'osm:map': { provider: 'osm', label: 'OpenStreetMap', url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', attribution: OSM_ATTR },
  'carto:light': { provider: 'carto', label: 'Carto Açık', url: 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', attribution: `${OSM_ATTR} &copy; CARTO` },
  'carto:dark': { provider: 'carto', label: 'Carto Koyu', url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png', attribution: `${OSM_ATTR} &copy; CARTO` },
  'google:roadmap': { provider: 'google', label: 'Google Yol', google: 'roadmap', attribution: 'Map data &copy; Google' },
  'google:satellite': { provider: 'google', label: 'Google Uydu', google: 'satellite', attribution: 'Imagery &copy; Google' },
};

export const googleTileUrl = (s) => `https://tile.googleapis.com/v1/2dtiles/{z}/{x}/{y}?session=${s.session}&key=${s.key}`;
export const tileUrl = (def, cfg) => (def.provider === 'carto' && cfg?.carto_key ? `${def.url}?key=${cfg.carto_key}` : def.url);
